import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { TestimonyService } from '../services';
import { TESTIMONIES_LIST_KEY } from '../constants';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useUpdateTestimonials = (testimonialsId: string) => {
  const { t } = useTranslation('manufacture');
  const queryClient = useQueryClient();

  return useMutation((status: string) => TestimonyService.update(testimonialsId, { enabled: status === 'true' }), {
    onSuccess: () => {
      toast.success(t('statusSuccessUpdate'));
      queryClient.invalidateQueries({ queryKey: [TESTIMONIES_LIST_KEY] }).then();
    },
    onError: () => {
      toast.error(t('generalErrorMessage', { ns: 'errors' }));
    },
  });
};

export default useUpdateTestimonials;
